<script setup lang="ts">
interface Breadcrumbs {
  slug: string
  title: string
}

const { items } = defineProps<{
  items?: Breadcrumbs[]
}>()
const config = useRuntimeConfig()
const siteName = config.public.siteName

const route = useRoute()
const state = useState<{ breadcrumbs: Breadcrumbs[]; title: string }>('breadcrumbs')
const breadcrumbs = items || state.value?.breadcrumbs || []

breadcrumbs.forEach((item) => {
  item.slug = useTrailingSlash(item.slug?.startsWith('/') ? `${item.slug}` : `/${item.slug}`)
})

const pages = [
  { slug: '/', title: siteName },
  ...breadcrumbs,
  { slug: route.path, title: state.value?.title },
]
</script>

<template>
  <div>
    <ul v-if="pages?.length" class="breadcrumbs flex md:hidden" :class="$attrs.class">
      <li class="breadcrumbs__item-mobile">
        <RouterLink :to="pages[pages.length - 2].slug">
          <span class="underline">{{ pages[pages.length - 2].title }}</span>
        </RouterLink>
      </li>
    </ul>
    <ul
      v-if="pages?.length"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
      class="breadcrumbs hidden md:flex"
      :class="$attrs.class"
    >
      <li
        v-for="(item, index) in pages"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
        class="breadcrumbs__item hidden md:flex md:items-center md:mx-2"
      >
        <RouterLink itemprop="item" class="flex" :to="item.slug">
          <span itemprop="name">{{ item.title }}</span>
        </RouterLink>
        <meta itemprop="position" :content="(index + 1).toString()">
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
.breadcrumbs {
  &__item > a {
    @apply text-small;
    span {
      @apply underline;
    }
    &:after {
      @apply px-1 flex items-center;
      content: ">";
    }
  }

  &__item:last-of-type > a {
    span {
      @apply no-underline;
    }

    &:after {
      content: "";
    }
  }
  &__item-mobile > a {
    @apply font-normal;

    &:before {
      content: "<";
      @apply pr-2;
    }
  }
}
</style>
